import { render, staticRenderFns } from "./ClientTaxUpload.vue?vue&type=template&id=f5280632&scoped=true"
import script from "./ClientTaxUpload.vue?vue&type=script&lang=js"
export * from "./ClientTaxUpload.vue?vue&type=script&lang=js"
import style0 from "./ClientTaxUpload.vue?vue&type=style&index=0&id=f5280632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5280632",
  null
  
)

export default component.exports